<script setup>
import HeadRegion from "@/components/HeadHome.vue"
import FootRegion from "@/components/FootRegion.vue"
</script>
<template>
      <HeadRegion></HeadRegion>
      <div class="content_width">
        <section class="slice py-7">
          <div class="container">
          </div>
        </section>   

        <!--人工智能开发系列课程-->
        <section class="slice slice-lg">
          <div id="idpython" class="container">
            <div class="row mb-5 justify-content-center text-center">
              <div class="col-lg-12">
                    <span class="badge badge-soft-success badge-pill badge-lg">
                        选择课程
                    </span>
                    <h2 class=" mt-4">人工智能开发系列课程</h2>
                    <div class="mt-2">
                        <p class="lead lh-180" style="text-align: justify;">人工智能开发就是开发人员通过技术和努力，让电脑变得像人一样聪明的过程。这个过程充满了挑战和机遇，也是未来科技发展的重要方向之一‌。</p>
                    </div>
                   <!-- Card -->
                   <div class="row mt-5">
                    <table style="width: 100%" border="1" cellspacing="0" cellpadding="10">
                          <tr align="center" style="background-color: azure;">
                            <td rowspan="6">第一阶段：基础课程</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">Python编程入门</td>
                            <td style="text-align: justify;">快速掌握Python编程技术</td>
                            <td>6周</td>
                            <td style="text-align: justify;">准备学习Python编程基础人群</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="opencourse('22a18aa0f0ac454abb378192ae429811')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">Numpy矩阵运算</td>
                            <td style="text-align: justify;">利用Numpy库进行高效的矩阵运算，为处理大规模数据集、进行科学计算和机器学习等任务打下坚实的基础</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">具备Pyhton编程基础，进一步学习应用Python进行矩阵运算</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('97863391-1027-47e2-8377-6ee50868f832')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">Scipy数值运算</td>
                            <td style="text-align: justify;">用于科学计算，包括数值计算。它提供了一些工具，如数值积分、微分、线性代数等</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">具备Pyhton编程基础，进一步学习应用Python进行数值运算</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('452759d3-ec99-4f18-90ca-0df62f65fa45')">进入课程</el-button>
                            </td>
                          </tr>

                          <tr align="center">
                            <td style="text-align: justify;">Pandas数据处理</td>
                            <td style="text-align: justify;">使用Pandas库进行数据处理分析</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">具备Pyhton编程基础，学习数据处理与分析</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('798863ce-75bb-4e6a-b3b4-21ed7b3e1943')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">Matplotlib数据可视化</td>
                            <td style="text-align: justify;">使用Matplotlib库将处理数据进行可视化展示</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">具备Pyhton编程基础，学习数据可视化应用</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('e0ee90c8-0db0-4589-be46-3dc25260cab2')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color: bisque;">
                            <td rowspan="3">第二阶段：机器学习阶段</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">机器学习数学基础</td>
                            <td style="text-align: justify;">学习人工智能领域常用的数学知识，包括线性代数、概率论、微积分、最优化问题等</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">具备Pyhton编程和第三方库应用基础</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('be2424a7-aff7-4825-ab77-2996ac8bb8b3')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">机器学习基础</td>
                            <td style="text-align: justify;">学习逻辑回归、决策树、随机森林等经典机器学习算法，理解其原理和应用场景。掌握特征工程、模型评估与优化等技术</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第一阶段基础课程、机器学习数学基础学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('e3c4c723b12843e7bfd320edeb6d47aa')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color:aliceblue">
                            <td rowspan="3">第三阶段：深度学习阶段</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">深度学习基础</td>
                            <td style="text-align: justify;">握神经网络的基本原理与应用技巧，为深入学习和实践深度学习算法打下坚实基础</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第二阶段课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('7f592a8b-7a39-4311-83bb-8798aba993aa')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">TensorFlow深度学习实战</td>
                            <td style="text-align: justify;">应用TensorFlow深度学习框架，完成人工智能实战项目开发</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成深度学习基础课程</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('e1fedcc1-7f1a-41ae-826b-ae61c8e2a69c')">进入课程</el-button>
                            </td>
                          </tr>

                       </table>

                   </div>
              </div>
            </div>
          </div>
        </section>

        <!--Java系列课程-->
        <section class="slice slice-lg">
          <div id="idjava" class="container">
            <div class="row mb-5 justify-content-center text-center">
              <div class="col-lg-12">
                    <span class="badge badge-soft-success badge-pill badge-lg">
                        选择课程
                    </span>
                    <h2 class=" mt-4">Java系列课程</h2>
                    <div class="mt-2">
                        <p class="lead lh-180" style="text-align: justify;">Java技术路线可以分为多个阶段，涵盖从基础到高级的全面学习。Java作为成熟的编程语言，广泛应用于企业级应用开发、大数据处理、云计算等领域。</p>
                    </div>
                   <!-- Card -->
                   <div class="row mt-5">
                     <table style="width: 100%" border="1" cellspacing="0" cellpadding="10">
                        <tr align="center" style="background-color: azure;">
                            <td rowspan="2">第一阶段：基础课程</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>学习要求</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">Java编程基础</td>
                            <td style="text-align: justify;">零基础入门，内容循序渐进，教学过程以编程案例为主导</td>
                            <td>8周</td>
                            <td td style="text-align: justify;">无基础要求</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="opencourse('9c60e50379024e10ab7a6c5f4944eedb')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color: bisque;">
                            <td rowspan="7">第二阶段：Java WEB开发</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">HTML5基础</td>
                            <td style="text-align: justify;">HTML5基础知识，HTML代码规范、HTML标签列表。学完课程后，可以独立制作HTML网页</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">无基础要求</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('9434831bf1434f6c93f3e9a930bb27a3')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">CSS基础</td>
                            <td style="text-align: justify;">CSS使用方法以及网页字体样式、布局样式、元素位置样式、填充及颜色样式等内容</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成HTML5基础课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('bba3db3e087e4f0b9a36b16645dad648')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">JavaScript基础</td>
                            <td style="text-align: justify;">JS编程基础、事件处理、DOM对象等</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成HTML5基础课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('4bd8e1c3afee4fb4bf25b4300680367a')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">MySQL数据库应用</td>
                            <td style="text-align: justify;">MySQL数据库的基本管理，包括数据库与数据库表的管理、SQL查询等</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成Java编程基础课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('e83a848c30ef49e2b5fc76a5551b0dfd')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">WEB服务器Tomcat</td>
                            <td style="text-align: justify;">Tomcat在Windows及Linux下的安装及使用方法</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成Java编程、MySQL数据库应用课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('002268a810b44535909dbb7c972716dd')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">VUE前端框架应用</td>
                            <td style="text-align: justify;">VUE从基础到进阶，掌握Vue.js的核心技术和实战应用</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第二阶段其它课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('87fcab0c-3133-4ff9-9871-6f2f9700fc12')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color:aliceblue">
                            <td rowspan="7">第三阶段：Java开发框架</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">服务器开发框架Spring</td>
                            <td style="text-align: justify;">学习如何通过Spring框架构建高效、可维护的服务器端应用程序，掌握依赖注入、事务管理、数据访问等高级特性</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第二阶段全部课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('d9908a0b-1efc-460e-971d-585c8167ed31')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">WEB开发框架SpringMVC</td>
                            <td style="text-align: justify;">学习如何使用SpringMVC框架接收前端请求和数据，经过处理后将结果响应给前端，以及如何处理请求和响应</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成服务器开发框架Spring课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('89938a5a-396c-484f-ad15-be4ff1de51e6')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">持久层开发框架Mybatis</td>
                            <td style="text-align: justify;">理解Mybatis基本概念，掌握Mybatis基本使用，学习Mybatis高级特性，能够应用Mybatis进行项目开发</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成WEB开发框架Spring MVC课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('c221fa71-9f7f-4cec-87a7-b61dab7bf815')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">服务快速开发技术Spring Boot</td>
                            <td style="text-align: justify;">通过理论讲解与实战演练相结合的方式，帮助学员全面掌握Spring Boot的开发技能，从基础到高级，再到实战项目，逐步提升解决实际问题的能力</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成WEB开发框架、持久层开发框架课程</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('60b36fcf-e99e-4a60-b3c1-1a7aff115603')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">版本控制Git</td>
                            <td style="text-align: justify;">能够高效地进行代码管理、版本追踪、团队协作，并理解Git背后的设计理念和工作原理</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成Spring Boot课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('306f4b45-6146-4ada-ba83-d1bba3d3440c')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">项目构建Maven</td>
                            <td style="text-align: justify;">利用Maven高效地构建和管理Java项目，提高开发效率和项目质量</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第三阶段其它课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('7dea0230-558f-4987-a7aa-f0e26a1c2ba2')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color:bisque;">
                            <td rowspan="6">第四阶段：中间件</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">消息中间件RabbitMQ</td>
                            <td style="text-align: justify;">学习如何通过Spring框架构建高效、可维护的服务器端应用程序，掌握依赖注入、事务管理、数据访问等高级特性</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第二阶段全部课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('b0166b55-2a3f-455c-af5c-ca7c08034f94')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">分布式缓存Redis</td>
                            <td style="text-align: justify;">掌握Redis在分布式缓存领域的应用技能，内容涵盖Redis的基本原理、数据类型、集群模式、持久化机制以及在实际应用中的最佳实践</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成消息中间件RabbitMQ课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('0378ba22-279e-43b5-a0db-0f96cd60173e')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">分布式搜索Elasticsearch</td>
                            <td style="text-align: justify;">分布式搜索引擎Elasticsearch的原理、应用、安装、配置及优化，能够掌握Elasticsearch在海量数据搜索、分析、监控等方面的能力</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成Java编程、MySQL数据库等课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('859bf5e2-e1d9-4c9b-9bf6-f7eda17ef001')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">分布式事务Spring Cloud Alibaba-seata</td>
                            <td style="text-align: justify;">掌握Seata的架构设计、核心组件、事务模式以及在实际项目中的部署、配置和应用</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成分布式相关中间件课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('4a80ad7d-1c95-461e-8342-538dde733522')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">微服务部署Docker</td>
                            <td style="text-align: justify;">理解Docker在微服务部署中的重要作用，掌握Docker镜像的构建、容器的管理以及Docker Compose等高级功能，为实际项目中的微服务部署打下坚实基础</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第二阶段课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('84cc798b-40cb-4b38-b2f4-770521ef3d37')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color:aliceblue;">
                            <td rowspan="2">第五阶段：项目实战</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">互联网服务项目：在线课程</td>
                            <td style="text-align: justify;">学习如何通过Spring框架构建高效、可维护的服务器端应用程序，掌握依赖注入、事务管理、数据访问等高级特性</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成第二阶段全部课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('6e7f0109-3d29-448a-b03f-9f3eea349419')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color:bisque;">
                            <td rowspan="3">第六阶段：企业面试</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>适用者</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">企业面试开发篇</td>
                            <td style="text-align: justify;">通过实战演练、理论讲解与案例分析相结合的方式，帮助你掌握最新的开发技术、提升解决问题的能力，并成功应对各类技术面试挑战</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成所有Java相关课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('90488c63-35b9-4b4f-9ec9-84653bc59058')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">企业面试虚拟机篇</td>
                            <td style="text-align: justify;">专注于虚拟机技术、容器化技术与云计算平台的相关知识</td>
                            <td>3周</td>
                            <td td style="text-align: justify;">已完成所有Java相关课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('515c17bb-7884-498e-8d90-4c0c8fca62b3')">进入课程</el-button>
                            </td>
                          </tr>

                     </table>
                   </div>
              </div>
            </div>
          </div>
        </section>

        <!--嵌入式开发系列课程-->
        <section class="slice slice-lg">
          <div id="idc" class="container">
            <div class="row mb-5 justify-content-center text-center">
              <div class="col-lg-12">
                <span class="badge badge-soft-success badge-pill badge-lg">
                        选择课程
                    </span>
                    <h2 class=" mt-4">嵌入式开发系列课程</h2>
                    <div class="mt-2">
                        <p class="lead lh-180" style="text-align: justify;">嵌入式开发工程师的市场需求非常大。随着物联网、人工智能等技术的不断发展，嵌入式系统的应用范围越来越广泛，对嵌入式开发工程师的需求也越来越高。同时，嵌入式开发工程师的薪资水平也相对较高，一般在10K-20K之间，具有较高的职业发展前景。</p>
                    </div>
                    <div class="row mt-5">
                      <table style="width: 100%" border="1" cellspacing="0" cellpadding="10">
                        <tr align="center" style="background-color: azure;">
                            <td rowspan="2">第一阶段：C语言基础</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>学习要求</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">C语言入门教程</td>
                            <td style="text-align: justify;">每个优秀开发者都应该精通C语言，这门课程专为所有没学过、没学好C语言的同学打造</td>
                            <td>8周</td>
                            <td td style="text-align: justify;">无基础要求</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="opencourse('fb1ba2a9e9f44131baaa5dd9cf014a15')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color: bisque;">
                            <td rowspan="2">第二阶段：51单片机开发</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>学习要求</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">51单片机开发</td>
                            <td style="text-align: justify;">初学嵌入式开发，学习51单片机非常必要，可以更好地理解嵌入式系统的基本原理和概念，掌握开发技能，为今后的嵌入式学习打下坚实的基础</td>
                            <td>8周</td>
                            <td td style="text-align: justify;">具有C语言编程基础、数字电路基础</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('44e432dc-e83d-41fc-a414-0d040942266e')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color: azure;">
                            <td rowspan="2">第三阶段：STM32单片机开发</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>学习要求</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">STM32单片机开发</td>
                            <td style="text-align: justify;">嵌入式开发初学者在掌握51单片机开发的基础上，学习STM32系列芯片开发相对比较容易，也为后续的学习打下坚实的基础。</td>
                            <td>8周</td>
                            <td td style="text-align: justify;">已完成51单片机开发课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('476c8057-3e7a-46f5-8090-d65cfde66d82')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color: bisque;">
                            <td rowspan="2">第四阶段：RTOS系统开发</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>学习要求</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">RTOS系统开发</td>
                            <td style="text-align: justify;">掌握FreeRTOS的核心功能，如任务管理、同步与通信机制、软件定时器、中断处理、内存管理以及低功耗模式等</td>
                            <td>8周</td>
                            <td td style="text-align: justify;">已完成STM32单片机开发课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('8af31d9a-f9f6-440b-8c50-8ae63af76ffd')">进入课程</el-button>
                            </td>
                          </tr>
                          <tr align="center" style="background-color: azure;">
                            <td rowspan="2">第五阶段：Linux系统开发</td>
                            <td>课程名称</td>
                            <td>课程描述</td>
                            <td>学习周期</td>
                            <td>学习要求</td>
                            <td>操作</td>
                          </tr>
                          <tr align="center">
                            <td style="text-align: justify;">Linux系统开发</td>
                            <td style="text-align: justify;">掌握RTOS后再学Linux可能会让你更快地适应和理解其复杂的系统架构</td>
                            <td>8周</td>
                            <td td style="text-align: justify;">已完成RTOS系统开发课程学习</td>
                            <td>                              
                               <el-button
                                  size="mini"
                                  type="primary"
                                  @click="zopencourse('4038a348-46e8-4463-b2ae-293820a88b5d')">进入课程</el-button>
                            </td>
                          </tr>

                      </table>
                    </div>
              </div>
            </div>
          </div>
        </section>
      </div>
   <FootRegion></FootRegion>
</template>
  
<script>
import { getCourseBody,getCourseListWithTag } from '@/api/course'
export default {
  name: 'App',
  data() {
    return {
      id:this.$route.query.id,
      coursedata:'',
      primecourse:'',
      pythonshowon:true,
      pythonshowcloase:false,
      tableData: [{
            studytime: '4周',
            name: 'Python编程入门',
            describe: '快速掌握Python编程技术',
            apply: '具备初中学历，无编程基础',
            guid:'22a18aa0f0ac454abb378192ae429811'
          }, {
            studytime: '6周',
            name: '网络爬虫',
            describe: '剖析算法,代码实现,安装配置,基础语法,抓取策略',
            apply: '具备Python编程能力',
            guid:'87f704b984f146cc81dad23b091e02e7'
          }, {
            studytime: '6周',
            name: '应用Python编程，提高办公效率',
            describe: '批量化、自动化、定制化来解决数据问题',
            apply: '具备Python编程能力',
            guid:'215d9c08-3042-450d-a297-e695c86ad568'
          }, {
            studytime: '6周',
            name: '利用Python进行数据分析',
            describe: '数据处理、数据可视化、数据分析',
            apply: '具备Python编程能力',
            guid:'e4286871a4d147f284ce421cbe5b661a'
          },
          {
            studytime: '20周',
            name: 'TensorFlow深度学习实战',
            describe: '使用Python学习TensorFlow可以快速提升你的人工智能学习曲线',
            apply: '具备Python编程基础和一定的数学基础',
            guid:'e1fedcc1-7f1a-41ae-826b-ae61c8e2a69c'
          }
        ]
    }
  },
  mounted() {
    if (typeof this.id != 'undefined') {
      console.log("id:"+ this.id)
      this.scrollToBox(this.id)
    }
  },
  created() {
   },
  methods: {
    handin()
    {
      this.$router.push('/java')
    },
    tableRowClassName({rowIndex}) {
        if (rowIndex === 1) {
          return 'warning-row';
        } else if (rowIndex === 3) {
          return 'success-row';
        }
        return '';
      },
    showCourseInfo(event) {
      console.log(event)
      this.primecourse[event].tag = '1'
      this.pythonshowon=false,
      this.pythonshowcloase=true

    },
    showBox(event) {
      console.log(event)
      this.primecourse[event].tag = '0'
      this.pythonshowon=true,
      this.pythonshowcloase=false
    },

    opencourse(courseid) {
      this.$router.push("/CourseInfo/" + courseid)
    },

    zopencourse(courseid) {
      this.$router.push("/CourseView/" + courseid)
    },

      // 获取课程
      async getCourseBodyAPI(){
            const  res  = await getCourseBody({"id":this.id})
            this.coursedata = res
            console.log(res)
            this.roleForm = {
                userid:this.userId,
                id:res.sguid,
                name:res.sname,
                issueDate:res.ddatetime,
                price:res.dprice,
                sealprice:res.dsaleprice,
                brief:res.stextbrief,
                coursecount:res.nallcount,
                photo:res.sphoto
            }
            this.roleForm.userid=this.userId;
          },
    // 获取课程
    async getCourseWithTagAPI(coursetag){
      const  res  = await getCourseListWithTag({"courseTag":coursetag})
      this.primecourse = res
      for( var i = 0; i < this.primecourse.length; i++ ) {
        this.primecourse[i].tag = '0'
      }
      console.log(res)
    },

    getphoto(obj) {
      console.log(obj.photo)
      return "http://www.milihua.com/" + obj.photo
    },
    scrollToBox(item) {
      const element = document.getElementById(item);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
   },
 
 }
</script>
<style scoped>
@import "@/styles/quick-website.css";
  .cpoint {
            cursor: pointer;
        }
 .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purplebox {
    border: 1px solid #fafafa;
    background: #fafafa;
    line-height: 45px;
    font-size: 18px;
    cursor: pointer;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 45px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

 </style>


